export const LOGIN = `SESSION/LOGIN`
export const LOGOUT = `SESSION/LOGOUT`
export const SET_BACK_URL = `SESSION/SET_BACK_URL`
export const LOGIN_PENDING = `SESSION/LOGIN_PENDING`
export const LOGIN_SUCCESS = `SESSION/LOGIN_SUCCESS`
export const LOGIN_ERROR = `SESSION/LOGIN_ERROR`
export const SET_TOKEN = `SESSION/SET_TOKEN`
export const SET_TOKENS = `SESSION/SET_TOKENS`
export const REQUEST = `SESSION/REQUEST`
export const REQUEST_SUCCESS = `SESSION/REQUEST_SUCCESS`
export const REQUEST_ERROR = `SESSION/REQUEST_ERROR`
export const LOCK_REQUESTS = `SESSION/LOCK_REQUESTS`
export const UNLOCK_REQUESTS = `SESSION/UNLOCK_REQUESTS`
export const REFRESH_TOKEN = `SESSION/REFRESH_TOKEN`
export const CLEAR_SESSION = `SESSION/CLEAR`
